import React, { useEffect, useRef, useState } from 'react';
import style from './media-player-style.module.scss';
import backgroundAudioMP3 from '../../sound/5sec.mp3';
import { GLOBAL_VARS } from '../../javascript/services/globalVars';

// Wrapper component that defers rendering until React is ready
function MediaPlayer() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Small delay to ensure React is fully initialized
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 150);

    return () => clearTimeout(timer);
  }, []);

  if (!isReady) {
    return <div className={`${style.audioWrap} `}></div>;
  }

  return <MediaPlayerInner />;
}

// Inner component with error boundary protection
class MediaPlayerInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.error('Media Player Error:', error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Media Player caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <div className={`${style.audioWrap} `}></div>;
    }

    return <MediaPlayerCore />;
  }
}

// Core component with the actual media player logic
function MediaPlayerCore() {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = new Audio(backgroundAudioMP3);
    audio.loop = true;
    audio.volume = 1;
    audioRef.current = audio;

    const updatePlayingState = () => {
      GLOBAL_VARS.background_sound_playing = !audio.paused && !audio.ended;
    };

    const handleClick = () => {
      if (!audio.paused) {
        return;
      }
      console.log('Playing Background Sound');
      audio.play().catch((error) => {
        console.error('Background sound play failed:', error);
      });
    };

    audio.addEventListener('play', updatePlayingState);
    audio.addEventListener('pause', updatePlayingState);
    audio.addEventListener('ended', updatePlayingState);

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
      audio.removeEventListener('play', updatePlayingState);
      audio.removeEventListener('pause', updatePlayingState);
      audio.removeEventListener('ended', updatePlayingState);
      audio.pause();
      GLOBAL_VARS.background_sound_playing = false;
    };
  }, []);

  return (
    <div className={`${style.audioWrap} `}></div>
  );
}

export default MediaPlayer;
